<p-dialog
  header="VIA PDF Viewer"
  [visible]="isVisible"
  (visibleChange)="toggleModal()"
  [style]="{ width: '90%', height: '100%' }"
  [resizable]="true"
  [draggable]="true"
  [maximizable]="true"
>
  <ng-template pTemplate="content">
    <iframe
      [src]="pdfUrl | safe"
      frameborder="0"
      width="100%"
      height="100%"
    ></iframe>
  </ng-template>
</p-dialog>
